// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010645/js/" + chunkId + "." + {"44":"b85bcf90","225":"6f19e1c0","481":"1076683b","486":"f801be3e","770":"c7ffa39e"}[chunkId] + ".0.45476023069580196.chunk.js";
};